import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import ROUTES from 'config/routes.json'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { isLoggedInSelector } from 'store/modules/user/selectors'

export default function AuthRedirect(): null {
  const loggedIn = useAppSelector(isLoggedInSelector)
  const router = useRouter()
  const query = useSearchParams()
  const referrerUrl = query.get('from')

  useEffect(() => {
    if (loggedIn) {
      const referrer = Array.isArray(referrerUrl) ? referrerUrl[0] : referrerUrl
      router.push(referrer || ROUTES.HOME)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn])

  return null
}
